export default __webpack_public_path__ + "a37ae68a6816331ab4380f2b5a95a425.png";